import { gqlRequest } from './gql-request';
import {
  ReportUrlFragment,
  SaveReportMutationVariables,
} from './graphql/generated';

export type PortalReportUploadArgs = {
  /** GraphQL endpoint URL */
  server: string;
  /** API key with write permissions */
  apiKey: string;
  /** GraphQL mutation variables */
  data: SaveReportMutationVariables;
  /** GraphQL request timeout in minutes */
  timeout?: number;
};

/**
 * Uploads report to Code PushUp portal via GraphQL mutation.
 * @param args GraphQL endpoint configuration and mutation variables.
 * @returns Saved report
 */
export async function uploadReportToPortal(
  args: PortalReportUploadArgs,
): Promise<ReportUrlFragment> {
  const { server, apiKey, data: variables, timeout } = args;
  const data = await gqlRequest({
    operation: 'saveReport',
    server,
    apiKey,
    variables,
    timeout,
  });
  return data.saveReport;
}
